import { HStack } from "@chakra-ui/react";
import {
  DataTable,
  ExportButton,
  MonthPicker,
  NavBar as NavBarCmp,
} from "@components/ui-kit";
import { useUserMonthlyReportExportLazyQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { observer } from "mobx-react-lite";

interface NavBarProps {
  period: { month: number; year: number };
  onChangePeriod: (value: { month: number; year: number }) => void;
}

const NavBar = ({ period, onChangePeriod }: NavBarProps) => {
  const [fetchUserMonthlyReport, { loading: loadingUserMonthlyReport }] =
    useUserMonthlyReportExportLazyQuery({
      onCompleted(data) {
        const url = data.userMonthlyReportExport;
        if (url) window.location.href = url;
      },
      ...onError(),
    });

  return (
    <DataTable.NavBar>
      <NavBarCmp>
        <HStack spacing="3">
          <MonthPicker value={period} onChange={onChangePeriod} />
          <ExportButton
            isLoading={loadingUserMonthlyReport}
            onClick={() =>
              fetchUserMonthlyReport({
                variables: { month: period.month + 1, year: period.year },
              })
            }
          />
        </HStack>
      </NavBarCmp>
    </DataTable.NavBar>
  );
};

export default observer(NavBar);
